<template>
  <section class="form-section settlement-history">
    <h1 class="form-section__title">
      {{ $t('FINANCE.SETTLEMENT_HISTORY.TITLE') }}
    </h1>

    <div class="row align-justify">
      <div class="small-12 columns">
        <CardApiError
          v-if="apiError"
          :error-text="$t('FINANCE.SETTLEMENT_HISTORY.API_ERROR')"
          @retry="getSettlementHistory"
        />

        <div v-else-if="report" class="table-responsive raised">
          <table class="table table--padded table--hover">
            <thead>
              <tr>
                <th>{{ $t('FINANCE.SETTLEMENT.AMOUNT') }}</th>
                <th>{{ $t('FINANCE.SETTLEMENT.REQUEST_DATE') }}</th>
                <th>{{ $t('FINANCE.SETTLEMENT.PAYMENT_ACCOUNT') }}</th>
                <th v-if="showReceiptColumn">
                  {{ $t('FINANCE.SETTLEMENT.RECEIPT') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in report" :key="index">
                <td>{{ currencyFormat(row.amount) }} {{ $t('RIALS') }}</td>
                <td v-if="row.request_date">
                  {{ translateDate(row.request_date) }}
                </td>
                <td v-else>
                  —
                </td>
                <td
                  v-if="row.payment_account"
                  class="text-latin settlement-history__account"
                  :class="{
                    'settlement-history__account--foreigner': $auth.check(
                      'foreigner',
                    ),
                  }"
                >
                  <span
                    v-if="$auth.check('foreigner')"
                    v-dompurify-html="row.payment_account"
                  />
                  <span v-else>{{ row.payment_account }}</span>
                </td>
                <td v-else>
                  —
                </td>
                <td v-if="showReceiptColumn">
                  <a
                    v-if="row.receipt"
                    :href="formatReceipLink(row.receipt)"
                    target="_blank"
                  >
                    <i class="material-icons">
                      exit_to_app
                    </i>
                    {{ $t('FINANCE.SETTLEMENT.RECEIPT_LINK') }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="card">
          <div
            v-show="isLoading"
            class="card__block card__block--loading"
            dir="ltr"
          >
            <HollowDotsSpinner
              :animation-duration="1000"
              :dot-size="12"
              :dots-num="3"
              :color="'#95a5a6'"
            />
          </div>
          <div v-show="!isLoading" class="card__block">
            {{ $t('FINANCE.SETTLEMENT_HISTORY.NO_DATA') }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HollowDotsSpinner from '@@/common/HollowDotsSpinner';

import { SETTLEMENT_REPORTS } from '@/store/types';

import { dateFormat } from '@/utils/date';
import { format as currencyFormat } from '@/utils/number';
import lang from '@/mixins/lang';

import CardApiError from '@@/common/CardApiError';

export default {
  name: 'SettlementReports',

  components: {
    HollowDotsSpinner,
    CardApiError,
  },
  mixins: [lang],

  data() {
    return {
      isLoading: false,
      apiError: false,
    };
  },

  computed: {
    report() {
      return this.$store.getters[SETTLEMENT_REPORTS];
    },

    showReceiptColumn() {
      return this.report.some(({ receipt }) => Boolean(receipt));
    },
  },

  created() {
    if (!this.report) {
      this.getSettlementHistory();
    }
  },

  methods: {
    currencyFormat,

    translateDate(date) {
      let toFormat = 'DD/MM/YYYY';

      if (this.lang === 'fa') {
        toFormat = 'jYYYY/jMM/jDD';
      }

      return dateFormat()(toFormat)(date);
    },

    getSettlementHistory() {
      this.apiError = false;
      this.isLoading = true;

      return this.$store
        .dispatch(SETTLEMENT_REPORTS)
        .then(() => {
          this.isLoading = false;
        })
        .catch(message => {
          if (message) {
            this.$message.error(message);
          }

          this.isLoading = false;
          this.apiError = true;
        });
    },

    formatReceipLink(link) {
      return `http://pardakht.cafebazaar.ir${link}`;
    },
  },
};
</script>

<style lang="scss">
.settlement-history {
  &__account {
    &--foreigner {
      direction: ltr;
    }
  }
}
</style>
